var pdp_vue;

function pauseVideo(){
  $('iframe').each(function(){
    $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
};

function handleize(str) {
  if (!str) {
    return '';
  }
  str = str.toLowerCase();
  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], "");
  }
  str = str.replace(/\W+/g, "-");
  if (str.charAt(str.length - 1) == "-") {
    str = str.replace(/-+\z/, "");
  }
  if (str.charAt(0) == "-") {
    str = str.replace(/\A-+/, "");
  }
  return str
};
window.addEventListener('DOMContentLoaded', function() {
  pdp_vue = new Vue({
    el: '.main-product',
    data(){
      return {
        media_items: media_items,
        description_open: false,
        selected_variant_id: initial_variant.id,
        variants: variants,
        sample_product: sample_product,
        option1: initial_variant.option1,
        option2: initial_variant.option2,
        option3: initial_variant.option3,
        quantity: 1,
        last_price: 0,
        addingSampleToCart: false,
        addingToCart: false,
        copied: false,
        active_media_index: 0,
        loaded: false,
        main_swiper: null,
        thumb_swiper: null,
        allowTouchStatus: allowTouchStatus
      }
    },
    methods: {
      toggleDescription: function(){
        this.description_open = !this.description_open;
        if(this.description_open){
          $('.product-description-contents').slideDown();
        }else{
          $('.product-description-contents').slideUp();
        }
      },
      changeColor: function(optionNum, value, show_lead_time = '', show_quick_ship = '', extended_lead_time = '', quick_ship = ''){
        //console.log(optionNum);
        //console.log(value);
        var self = this;
        //console.log(self.selected_color);
        //console.log(self.selected_profile);
        
        if(show_quick_ship == "True"){
          $(".quick-ship").html(quick_ship);
          $(".quick-ship").removeClass("hideit");
          $(".quick-ship").addClass("showit");
        }else{
          $(".quick-ship").html("");
          $(".quick-ship").removeClass("showit");
          $(".quick-ship").addClass("hideit");
        }

        if(show_lead_time == "True"){
          $(".extended-lead-time").html(extended_lead_time);
          $(".extended-lead-time").removeClass("hideit");
          $(".extended-lead-time").addClass("showit");
        }else{
          $(".extended-lead-time").html("");
          $(".extended-lead-time").removeClass("showit");
          $(".extended-lead-time").addClass("hideit");
        }
        
        var previous_media_indexes = self.filtered_media_items.map(function(i){ return i.index });
        //console.log(previous_media_indexes);
        self['option'+optionNum] = value;
        self.checkSelectedVariant();
        
        var changed = false;
        var new_media_indexes = self.filtered_media_items.map(function(i){ return i.index });
        //console.log(new_media_indexes);
        if(new_media_indexes.length > 0){
          previous_media_indexes.forEach(function(i){
            if(!new_media_indexes.includes(i)){
              
              var slideToRemove = parseInt( $('.swiper-slide[data-image-index="'+i+'"]').index() );
              self.main_swiper.removeSlide(slideToRemove);
              self.thumb_swiper.removeSlide(slideToRemove);
              changed = true;
            }
          });
          new_media_indexes.reverse();
          new_media_indexes.forEach(function(i){
            if(!previous_media_indexes.includes(i)){
              var media = self.filtered_media_items.find(m => m.index == i)
              self.main_swiper.prependSlide(`
                <div class="swiper-slide" data-image-index="${i}">
                  ${media.html}
                </div>
              `);
              self.thumb_swiper.prependSlide(`
                <div class="swiper-slide" data-image-index="${i}">
                  ${media.thumbnail_html}
                </div>
              `);
              changed = true;
            }
          });
        }
        //console.log(changed);
        if(changed){
          self.main_swiper.update();
          self.main_swiper.slideTo(0);
          $('.main-product__thumbnail-overlay').remove();
          if(self.filtered_media_items.length < 2){
            $('#thumbnail-product-swiper-' + section_id).hide();
          } else {
            $('#thumbnail-product-swiper-' + section_id).show();
          }
          self.thumb_swiper.update();
          self.thumb_swiper.slideTo(0);
          if(self.filtered_media_items.length > 4){
            $('.main-product__thumbnails .swiper-slide').eq(3).find('.media').append('<div class="main-product__thumbnail-overlay">+'+(self.filtered_media_items.length - 3)+'</div>')
          }
        }
      },
      changeProfile: function(optionNum, value, show_lead_time = '', show_quick_ship = '', extended_lead_time = '', quick_ship = ''){
        //console.log(optionNum);
        //console.log(value);
        var self = this;
        //console.log(self);
        //console.log(self.selected_color);
        //console.log(self.selected_profile);
        
        if(show_quick_ship == "True"){
          $(".quick-ship").html(quick_ship);
          $(".quick-ship").removeClass("hideit");
          $(".quick-ship").addClass("showit");
        }else{
          $(".quick-ship").html("");
          $(".quick-ship").removeClass("showit");
          $(".quick-ship").addClass("hideit");
        }

        if(show_lead_time == "True"){
          $(".extended-lead-time").html(extended_lead_time);
          $(".extended-lead-time").removeClass("hideit");
          $(".extended-lead-time").addClass("showit");
        }else{
          $(".extended-lead-time").html("");
          $(".extended-lead-time").removeClass("showit");
          $(".extended-lead-time").addClass("hideit");
        }
        
        var previous_media_indexes = self.filtered_media_items.map(function(i){ return i.index });
        //console.log(previous_media_indexes);
        self['option'+optionNum] = value;
        self.checkSelectedVariant();
        
        var changed = false;
        var new_media_indexes = self.filtered_media_items.map(function(i){ return i.index });
        //console.log(new_media_indexes);
        if(new_media_indexes.length > 0){
          previous_media_indexes.forEach(function(i){
            if(!new_media_indexes.includes(i)){
              
              var slideToRemove = parseInt( $('.swiper-slide[data-image-index="'+i+'"]').index() );
              self.main_swiper.removeSlide(slideToRemove);
              self.thumb_swiper.removeSlide(slideToRemove);
              changed = true;
            }
          });
          new_media_indexes.reverse();
          new_media_indexes.forEach(function(i){
            if(!previous_media_indexes.includes(i)){
              var media = self.filtered_media_items.find(m => m.index == i)
              self.main_swiper.prependSlide(`
                <div class="swiper-slide" data-image-index="${i}">
                  ${media.html}
                </div>
              `);
              self.thumb_swiper.prependSlide(`
                <div class="swiper-slide" data-image-index="${i}">
                  ${media.thumbnail_html}
                </div>
              `);
              changed = true;
            }
          });
        }
        //console.log(changed);
        if(changed){
          self.main_swiper.update();
          self.main_swiper.slideTo(0);
          $('.main-product__thumbnail-overlay').remove();
          if(self.filtered_media_items.length < 2){
            $('#thumbnail-product-swiper-' + section_id).hide();
          } else {
            $('#thumbnail-product-swiper-' + section_id).show();
          }
          self.thumb_swiper.update();
          self.thumb_swiper.slideTo(0);
          if(self.filtered_media_items.length > 4){
            $('.main-product__thumbnails .swiper-slide').eq(3).find('.media').append('<div class="main-product__thumbnail-overlay">+'+(self.filtered_media_items.length - 3)+'</div>')
          }
        }
      },
      checkSelectedVariant: function(){
        var self = this;
        var search = self.variants.find(function(v){
          return v.option1 == self.option1 && v.option2 == self.option2 && v.option3 == self.option3
        });
        if(search){
          self.selected_variant_id = search.id;
          self.last_price = self.selected_variant.price;
        } else {
          self.selected_variant_id = null;
        }
        if(self.selected_variant_id){
          var urlParams = new URLSearchParams(window.location.search);
          urlParams.set('variant', self.selected_variant.id);
          window.history.replaceState({ variantId: self.selected_variant.id }, '', '?' + urlParams.toString() );
          $('[data-variant]').each(function(){
            $(this).attr('data-variant', self.selected_variant.id);
            var html = $(this)[0].outerHTML;
            $(this).after(html);
            $(this).remove();
          });
          setTimeout(function(){
            if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
          },200);

          if (window.swapSalsifyVariants && self.loaded != false) {
           swapSalsifyVariants(self.selected_variant.barcode);
         }
          if (window.ChangeVariantMetaFields && self.loaded != false) {
           ChangeVariantMetaFields(self.selected_variant.id);
         }
        }
      },
      setQuantity: function(value){
        if(value < 1){
          this.quantity = 1;
          return;
        }
        this.quantity = value;
      },
      addToCart: function(){
        var self = this;
        self.addingToCart = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                quantity: self.quantity,
                id: self.selected_variant_id
              }
            ]
          })
        })
        .then(response => response.json())
        .then(() => {
          self.addingToCart = false;
          var update_variant = self.selected_variant;
          update_variant.inventory_quantity -= self.quantity;
          self.variants.splice(self.variants.findIndex(function (v) { return v.id == update_variant.id }), 1, update_variant);
          CartDrawer.renderCart(true);
        });
      },
      addSampleToCart: function(){
        var self = this;
        self.addingSampleToCart = true;
        $('.pdp-sticky-button').addClass('button--loading');
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          type: 'POST',
          data: {
            items: [
              {
                quantity: 1,
                id: self.selected_sample_variant.id
              }
            ]
          },
          success: function(){
            self.addingSampleToCart = false;
            $('.pdp-sticky-button').removeClass('button--loading');
            CartDrawer.renderCart(true);
          }
        });
      },
      share: function(){
        var self = this;
        if (navigator.share) {
          navigator.share({
            title: product_title,
            url: window.location.href
          })
          .catch(console.error);
        } else {
          navigator.clipboard.writeText(window.location.href);
          self.copied = true;
          setTimeout(function(){
            self.copied = false;
          }, 1500);
        }
      }
    },
    computed: {
      filtered_media_items: function(){
        var self = this;
        var thissel = '';
        if(self.selected_variant.option1 == 'Regency' || self.selected_variant.option1 == 'Classic' || self.selected_variant.option1 == 'Deluxe' || self.selected_variant.option1 == 'Traditional' || self.selected_variant.option1 == 'Contemporary')
          thissel = self.selected_profile;
        else
          thissel = self.selected_color;
        return self.media_items.filter(function(i) {
          return i.alt == thissel;
        }).concat(self.media_items.filter(function(i) {
          return i.alt == product_title;
        }));
      },
      add_to_cart_text: function(){
        var self = this;
        if(self.selected_variant_id == null){
          return add_to_cart_text_no_variant;
        }
        var v = self.selected_variant;
        if(v.inventory_management == 'shopify' && v.requires_shipping){
          if(v.inventory_quantity < self.quantity){
            if(v.inventory_policy == 'continue'){
              return add_to_cart_text_continue;
            } else if(v.inventory_quantity == 0) {
              return add_to_cart_text_no_inventory;
            } else {
              return add_to_cart_text_low_inventory.replace('[quantity]', v.inventory_quantity);
            }
          }
        }
        return add_to_cart_text_available;
      },
      add_to_cart_disabled: function(){
        var self = this;
        if(self.selected_variant_id == null){
          return true;
        }
        var v = self.selected_variant;
        if(v.inventory_management == 'shopify' && v.requires_shipping){
          if(v.inventory_quantity < self.quantity){
            if(v.inventory_policy == 'continue'){
              return false;
            } else {
              return true;
            }
          }
        }
        return false;
      },
      selected_variant: function(){
        var self = this;
        var variant = self.variants.find(function(v){ return v.id == self.selected_variant_id });
        if(variant){
          return variant;
        }else{
          return { price: null, sku: 'N/A' };
        }
      },
      selected_color: function(){
        var self = this;
        var options = product_options;
        var color = options.find(o => o.name.toLowerCase() == 'color');
        
        if(color){
          return self['option'+color.position]
        }
        
        return null;
      },
      selected_profile: function(){
        var self = this;
        var options = product_options;
        var profile = options.find(o => o.name.toLowerCase() == 'rail profile');
        if(profile){
          return self['option'+profile.position]
        }
        return null;
      },
      selected_sample_variant: function(){
        var self = this;
        if (!self.sample_product) {
          document.querySelector('.pdp-sticky-button').disabled = true;
          document.querySelector('.pdp-sticky-button').style.display = 'none';
          return null;
        }
        
        if(self.sample_product.options){
          // for color option
          var v = self.sample_product.variants.find( v => v.option1 == self.selected_color );
          
          if (v) {
            document.querySelector('.pdp-sticky-button').style.display = 'flex';
            if(v.available){
              document.querySelector('.pdp-sticky-button').disabled = false;
            } else {
              document.querySelector('.pdp-sticky-button').disabled = true;
            }
            return v;
          }

          // for profile option
          var vp = self.sample_product.variants.find( vp => vp.option1 == self.selected_profile );
          console.log(vp);
          if (vp) {
            document.querySelector('.pdp-sticky-button').style.display = 'flex';
            if(vp.available){
              document.querySelector('.pdp-sticky-button').disabled = false;
            } else {
              document.querySelector('.pdp-sticky-button').disabled = true;
            }
            return vp;
          }
        }
        
        document.querySelector('.pdp-sticky-button').disabled = true;
        document.querySelector('.pdp-sticky-button').style.display = 'none';
        return null;
      }
    },
    filters: {
      currency: function(value){
        if(typeof value !== 'number'){
          return value;
        }
        value = value / 100.00;
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2
        });
        return formatter.format(value);
      }
    },
    mounted: function(){
      var self = this;
      self.thumb_swiper = new Swiper('#thumbnail-product-swiper-' + section_id, {
        slidesPerView: 4,
        spaceBetween: 12,
        watchSlidesProgress: true,
        breakpoints: {
          750: {
            spaceBetween: 40
          }
        },
        on: {
          afterInit: function(s){
            if(self.filtered_media_items.length > 4){
              $('.main-product__thumbnails .swiper-slide').eq(3).find('.media').append('<div class="main-product__thumbnail-overlay">+'+(self.filtered_media_items.length - 3)+'</div>')
            }
            if(self.filtered_media_items.length < 2){
              $('#thumbnail-product-swiper-' + section_id).hide();
            } else {
              $('#thumbnail-product-swiper-' + section_id).show();
            }
          }
        }
      });
      self.main_swiper = new Swiper('#main-product-swiper-' + section_id, {
        allowTouchMove: self.allowTouchStatus,
        autoHeight: true,
        thumbs: {swiper: self.thumb_swiper},
        navigation: {
          nextEl: '.main-product-slider-arrow-next',
          prevEl: '.main-product-slider-arrow-prev',
        },
        on: {
          realIndexChange: function (s) {
            pauseVideo();
            $('.main-product__thumbnail-overlay').remove();
            var slide = $('.main-product__swiper [aria-label="' + (s.realIndex + 1) + ' / ' + self.filtered_media_items.length + '"]');
            if ($(slide).find('.external_video_placeholder').length > 0 ){
              var ind = $(slide).attr('data-image-index');
              $(slide).append(self.media_items.find(m => ind == m.index).iframe);
              $(slide).find('.external_video_placeholder').remove();
            }
          }
        }
      });

      self.option1 = self.selected_variant.option1;
      self.option2 = self.selected_variant.option2;
      self.option3 = self.selected_variant.option3;
      self.checkSelectedVariant();
      self.loaded = true;
    },
    delimiters: ['<%', '%>']
  });
});
